import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Header, Footer, LeftMenu } from '../commons/components';
import { Link } from 'react-router-dom';
import { usePageSettingHeaderStore } from '../commons/stores';
import { DetailContent } from './components/DetailContent';
import { useDispatch } from 'react-redux';
import { getSingleTheme } from '../redux/actions/actTheme';
import { useSelector } from 'react-redux';
// import { useEditStore } from './stores';

export default function Detail({ setCurrentId }) {
  const { id } = useParams();
  const [statePageSettingHeader] = usePageSettingHeaderStore();
  const dispatch = useDispatch();
  const themes = useSelector((state) => state.redTheme);
  //   const [state, actions] = useEditStore();
  //   const themes = useSelector((state) => state.redTheme);

  useEffect(() => {
    document.title = `Theme Detail - Ubaform Admin`;
    // actions.findData({ _id: id });
    dispatch(getSingleTheme(id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setCurrentId, dispatch]);

  let contentUi = <div className='loader-block' />;
  if (!themes.isLoading) {
    contentUi = (
      <React.Fragment>
        <DetailContent data={setCurrentId} />
        {/* {console.log('ini state Detail', themes)} */}
      </React.Fragment>
    );
  }

  //   console.log('ini theme Detail', theme);

  return (
    <div className='App'>
      <Header />
      {statePageSettingHeader.leftMenu ? <LeftMenu /> : null}

      <main className='workspace'>
        <section className='breadcrumb lg:flex items-start'>
          <div>
            <h1>Theme's Detail</h1>
            <ul>
              <li>
                <Link to='/theme-management'>Theme</Link>
              </li>
              {/* <li className='divider la la-arrow-right'></li>
              <li>List of Themes</li> */}
              <li className='divider la la-arrow-right'></li>
              <li>Theme's Detail</li>
            </ul>
          </div>
          <div className='lg:flex items-center ml-auto mt-5 lg:mt-0'>
            <div className='flex mt-5 lg:mt-0'>
              <Link
                to={`/theme-management/edit/${id}`}
                className='mr-3 bg-primary text-white font-semibold py-2 px-4 border border-grey-500 rounded'
              >
                Edit theme
              </Link>
              <Link
                to='/theme-management'
                className='bg-transparent text-primary font-semibold py-2 px-4 border border-grey-500 rounded'
              >
                Back to list
              </Link>
            </div>
          </div>
        </section>

        {/* <DetailContent data={state.form} /> */}
        {/* <DetailContent /> */}
        {contentUi}
        <Footer />
      </main>
    </div>
  );
}
